import { Button, ButtonStyle, colors } from '@one-tree/library'
import React, { Component, ReactNode } from 'react'
import styled from 'styled-components'

const Overlay = styled.div`
  min-height: 100vh;
  background-color: ${colors.lightGray};
  display: flex;
  align-items: center;
  justify-content: center;
`

const Card = styled.div`
  background-color: ${colors.white};
  border-radius: 5px;
  padding: 30px;
  max-width: 400px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 20px;

  h2 {
    margin: 0;
    color: ${colors.red};
  }
  p {
    margin: 0 0 5px;
    color: ${colors.darkestGray};
  }
`

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  handleBack = (): void => {
    this.setState({ error: null })
    window.history.back()
  }

  render(): ReactNode {
    const { children } = this.props
    const { error } = this.state

    if (error) {
      const env = process.env.REACT_APP_API_HOST
      const isStaging = Boolean(env && env.includes('one-tree.dev/api'))

      return (
        <Overlay>
          <Card>
            <h2>Something went wrong</h2>
            {isStaging && <p>{error.message}</p>}
            <Button
              buttonStyle={ButtonStyle.Secondary}
              onClick={this.handleBack}
            >
              Go back
            </Button>
          </Card>
        </Overlay>
      )
    }

    return children
  }
}
